export default __webpack_public_path__ + "static/media/start.4196d480.jpg";